import { listen, sendLocal } from "../channels";
import { filterMessage } from "../helpers";
import { isData } from "../message";
import { isTokenMessage } from "../messages/token";
import { tokenRequestMessage } from "../messages/token-request";
export var getToken = function getToken() {
  return new Promise(function (res, rej) {
    var timeOut = setTimeout(function () {
      return rej("getPlatform timed out");
    }, 15 * 1000);
    var unsub = listen(filterMessage(isTokenMessage)(function (message) {
      if (isData(message)) {
        var _message$payload;
        var _token = ((_message$payload = message.payload) === null || _message$payload === void 0 ? void 0 : _message$payload.token) || null;
        unsub();
        clearTimeout(timeOut);
        res(_token);
      }
    }));
    sendLocal(tokenRequestMessage());
  });
};
export var listenForToken = function listenForToken(cb) {
  var unsub = listen(filterMessage(isTokenMessage)(function (message) {
    if (isData(message)) {
      cb(message.payload);
    }
  }));

  // send an inital token request
  sendLocal(tokenRequestMessage());
  return unsub;
};